"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _uiKit = require("@devsta/ui-kit");

var _clientAwsS = require("@devsta/client-aws-s3");

var _TeamMemberItem = _interopRequireDefault(require("../../TeamMemberItem"));

var _formatRoleName = _interopRequireDefault(require("../../../utils/formatRoleName"));

require("../styles/_invite-users.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var INITIAL_STATE = function INITIAL_STATE(roleOptions) {
  return {
    inviteEmails: '',
    emailsInputValid: true,
    selectedTeam: void 0,
    team: void 0,
    selectedRole: roleOptions[0]
  };
};

var validateEmail = function validateEmail(value) {
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})$/.test(value);
};

var NO_TEAM_OPTION = {
  label: 'None',
  value: null
};

var isInvitedEmailAdded = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getOrgMembership, email) {
    var _yield$getOrgMembersh, data, error;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getOrgMembership({
              email: email
            });

          case 2:
            _yield$getOrgMembersh = _context.sent;
            data = _yield$getOrgMembersh.data;
            error = _yield$getOrgMembersh.error;

            if (!(!data || error)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", false);

          case 7:
            return _context.abrupt("return", !data.getOrgMembership);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function isInvitedEmailAdded(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getRoleOptions = (0, _memoizeOne.default)(function (organisationRoles) {
  return organisationRoles.map(function (_ref2) {
    var roleId = _ref2.roleId,
        name = _ref2.name;
    return {
      value: roleId,
      label: (0, _formatRoleName.default)(name)
    };
  });
});
var getTeamOptions = (0, _memoizeOne.default)(function (teams) {
  return [NO_TEAM_OPTION].concat(_toConsumableArray(teams.map(function (_ref3) {
    var teamItemId = _ref3.teamId,
        name = _ref3.name;
    return {
      label: name,
      value: teamItemId
    };
  })));
});

var InviteUsersModal = /*#__PURE__*/function (_Component) {
  _inherits(InviteUsersModal, _Component);

  var _super = _createSuper(InviteUsersModal);

  function InviteUsersModal(props) {
    var _this;

    _classCallCheck(this, InviteUsersModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleTagsChange", function (value) {
      _this.setState({
        inviteEmails: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTeamChange", function (option) {
      _this.setState({
        selectedTeam: option.value ? option : void 0
      });

      if (!option.value) {
        _this.setState({
          team: void 0
        });

        return;
      }

      _this.fetchTeam(option.value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRoleChange", function (option) {
      _this.setState({
        selectedRole: option
      });
    });

    _defineProperty(_assertThisInitialized(_this), "emailValidation", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value) {
        var _this$props, orgMemberships, getOrgMembership, orgMembersEmails;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = _this.props, orgMemberships = _this$props.orgMemberships, getOrgMembership = _this$props.getOrgMembership;

                if (validateEmail(value)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", false);

              case 3:
                if (orgMemberships) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", isInvitedEmailAdded(getOrgMembership, value));

              case 5:
                orgMembersEmails = orgMemberships.map(function (_ref5) {
                  var userEmail = _ref5.userEmail;
                  return userEmail;
                });
                return _context2.abrupt("return", !orgMembersEmails.includes(value));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onEmailsValidation", function (emailsInputValid) {
      _this.setState({
        emailsInputValid: emailsInputValid
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fetchTeam", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(teamId) {
        var _this$props2, getTeam, apiClient, _yield$getTeam, data, error, members, membersWithoutImages, teamWithImages;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props2 = _this.props, getTeam = _this$props2.getTeam, apiClient = _this$props2.apiClient;
                _context3.next = 3;
                return getTeam(teamId);

              case 3:
                _yield$getTeam = _context3.sent;
                data = _yield$getTeam.data;
                error = _yield$getTeam.error;

                if (!(error || !data.getTeam)) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return", void _this.setState({
                  team: void 0
                }));

              case 8:
                members = data.getTeam.members;
                membersWithoutImages = members.map(function (member) {
                  return _objectSpread(_objectSpread({}, member), {}, {
                    user: _objectSpread(_objectSpread({}, member.user), {}, {
                      imageUrl: void 0
                    })
                  });
                });

                _this.setState({
                  team: _objectSpread(_objectSpread({}, data.getTeam), {}, {
                    members: membersWithoutImages
                  })
                });

                _context3.next = 13;
                return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                  apiClient: apiClient,
                  dataArray: members,
                  substitutedKeys: [{
                    key: 'user',
                    subKeys: ['imageUrl']
                  }],
                  organisationId: data.getTeam.organisationId
                });

              case 13:
                teamWithImages = _context3.sent;

                _this.setState({
                  team: _objectSpread(_objectSpread({}, data.getTeam), {}, {
                    members: teamWithImages
                  })
                });

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleModalSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _this$props3, inviteUsersToOrgAndTeam, onClose, onInvited, organisationRoles, _this$state, inviteEmails, selectedTeam, selectedRole, emails, _yield$inviteUsersToO, error;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props3 = _this.props, inviteUsersToOrgAndTeam = _this$props3.inviteUsersToOrgAndTeam, onClose = _this$props3.onClose, onInvited = _this$props3.onInvited, organisationRoles = _this$props3.organisationRoles;
              _this$state = _this.state, inviteEmails = _this$state.inviteEmails, selectedTeam = _this$state.selectedTeam, selectedRole = _this$state.selectedRole;
              emails = inviteEmails.split(',');
              _context4.next = 5;
              return inviteUsersToOrgAndTeam({
                emails: emails,
                teamId: selectedTeam && selectedTeam.value,
                roleId: selectedRole ? selectedRole.value : organisationRoles[0].roleId
              });

            case 5:
              _yield$inviteUsersToO = _context4.sent;
              error = _yield$inviteUsersToO.error;

              if (!error) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt("return");

            case 9:
              onInvited();
              onClose();

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    _defineProperty(_assertThisInitialized(_this), "renderTeamMembers", (0, _lodash.default)(function (team) {
      if (!team || !(team && team.members.length)) {
        return null;
      }

      var teamId = team.teamId,
          members = team.members;
      return /*#__PURE__*/_react.default.createElement(_uiKit.LabelWrapper, {
        className: "invite-users__team-label",
        label: "Current Users In ".concat(team.name),
        helper: "Users will be added to this team with a default user role"
      }, /*#__PURE__*/_react.default.createElement("div", {
        key: teamId,
        className: "invite-users__team"
      }, members.map(function (_ref8) {
        var teamMembershipId = _ref8.teamMembershipId,
            user = _ref8.user;
        return /*#__PURE__*/_react.default.createElement(_TeamMemberItem.default, {
          key: teamMembershipId,
          user: user
        });
      })));
    }));

    _defineProperty(_assertThisInitialized(_this), "clearState", function () {
      var organisationRoles = _this.props.organisationRoles;

      _this.setState(_objectSpread({}, INITIAL_STATE(getRoleOptions(organisationRoles))));
    });

    var _organisationRoles = props.organisationRoles;
    _this.state = _objectSpread({}, INITIAL_STATE(getRoleOptions(_organisationRoles)));
    return _this;
  }

  _createClass(InviteUsersModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref9) {
      var prevVisible = _ref9.visible;
      var visible = this.props.visible;
      var isModalOpening = visible && !prevVisible;

      if (!isModalOpening) {
        return;
      }

      this.clearState();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          visible = _this$props4.visible,
          onClose = _this$props4.onClose,
          organisationRoles = _this$props4.organisationRoles,
          teams = _this$props4.teams,
          showTeamSelection = _this$props4.showTeamSelection;
      var _this$state2 = this.state,
          inviteEmails = _this$state2.inviteEmails,
          selectedTeam = _this$state2.selectedTeam,
          team = _this$state2.team,
          emailsInputValid = _this$state2.emailsInputValid,
          selectedRole = _this$state2.selectedRole;
      var roleOptions = getRoleOptions(organisationRoles);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "invite-users"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
        visible: visible,
        onClose: onClose,
        key: "invite-users-modal",
        title: "Invite Users",
        onSave: this.handleModalSave,
        saveText: "Save & Continue",
        saveDisabled: !inviteEmails || !emailsInputValid || !selectedRole,
        stayOpenOnSave: true
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "invite-users__details"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "invite-users__emails"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.TagInput, {
        label: "Enter one or more email addresses",
        labelProps: {
          required: true
        },
        onChange: this.handleTagsChange,
        defaultValue: inviteEmails,
        tagValidation: this.emailValidation,
        validate: this.onEmailsValidation,
        errorMessage: "One or more of the entered emails are invalid/are already part of your Organisation"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "invite-users__role"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Dropdown, {
        "data-cy": "role-dropdown",
        label: "Organisation Role",
        options: roleOptions,
        onChange: this.handleRoleChange,
        defaultValue: selectedRole,
        type: "BUTTON",
        labelProps: {
          required: true
        }
      })), showTeamSelection && teams && teams.length ? /*#__PURE__*/_react.default.createElement("div", {
        className: "invite-users__team-info"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Dropdown, {
        "data-cy": "teams-dropdown",
        id: "teams",
        label: "Add Them To A Team",
        placeholder: "Select a team",
        onChange: this.handleTeamChange,
        defaultValue: selectedTeam || NO_TEAM_OPTION,
        options: getTeamOptions(teams),
        type: "BUTTON"
      })) : null, this.renderTeamMembers(team))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.selectedTeam && prevState.selectedTeam !== nextProps.selectedTeam) {
        return {
          selectedTeam: nextProps.selectedTeam
        };
      }

      return null;
    }
  }]);

  return InviteUsersModal;
}(_react.Component);

_defineProperty(InviteUsersModal, "defaultProps", {
  showTeamSelection: true
});

var _default = InviteUsersModal;
exports.default = _default;